module.exports = __webpack_public_path__ + "img/magafaim_no.650e5d2e.png";